import { assign, BoundedBuffer, combine, createContextManager, makePublicApi, monitor, display, deepClone, canUseEventBridge } from '@datadog/browser-core';
import { validateAndBuildLogsConfiguration } from '../domain/configuration';
import { Logger } from '../domain/logger';
import { createSender } from '../domain/sender';
export function makeLogsPublicApi(startLogsImpl) {
  var isAlreadyInitialized = false;
  var globalContextManager = createContextManager();
  var customLoggers = {};
  var beforeInitSendLog = new BoundedBuffer();

  var _sendLogStrategy = function sendLogStrategy(message, currentContext) {
    beforeInitSendLog.add(function () {
      return _sendLogStrategy(message, currentContext);
    });
  };

  var getInitConfigurationStrategy = function getInitConfigurationStrategy() {
    return undefined;
  };

  var sender = createSender(sendLog);
  var logger = new Logger(sender);
  return makePublicApi({
    logger: logger,
    init: monitor(function (initConfiguration) {
      if (canUseEventBridge()) {
        initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
      }

      if (!canInitLogs(initConfiguration)) {
        return;
      }

      var configuration = validateAndBuildLogsConfiguration(initConfiguration);

      if (!configuration) {
        return;
      }

      _sendLogStrategy = startLogsImpl(configuration, sender).send;

      getInitConfigurationStrategy = function getInitConfigurationStrategy() {
        return deepClone(initConfiguration);
      };

      beforeInitSendLog.drain();
      isAlreadyInitialized = true;
    }),
    getLoggerGlobalContext: monitor(globalContextManager.get),
    setLoggerGlobalContext: monitor(globalContextManager.set),
    addLoggerGlobalContext: monitor(globalContextManager.add),
    removeLoggerGlobalContext: monitor(globalContextManager.remove),
    createLogger: monitor(function (name, conf) {
      if (conf === void 0) {
        conf = {};
      }

      var sender = createSender(sendLog, conf.handler, conf.level, assign({}, conf.context, {
        logger: {
          name: name
        }
      }));
      customLoggers[name] = new Logger(sender);
      return customLoggers[name];
    }),
    getLogger: monitor(function (name) {
      return customLoggers[name];
    }),
    getInitConfiguration: monitor(function () {
      return getInitConfigurationStrategy();
    })
  });

  function overrideInitConfigurationForBridge(initConfiguration) {
    return assign({}, initConfiguration, {
      clientToken: 'empty'
    });
  }

  function canInitLogs(initConfiguration) {
    if (isAlreadyInitialized) {
      if (!initConfiguration.silentMultipleInit) {
        display.error('DD_LOGS is already initialized.');
      }

      return false;
    }

    return true;
  }

  function sendLog(message) {
    _sendLogStrategy(message, combine({
      date: Date.now(),
      view: {
        referrer: document.referrer,
        url: window.location.href
      }
    }, globalContextManager.get()));
  }
}